import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isNavOpen: false,
  vertical: "",
  verticalID:null,
  category: "",
  categoryID:null,
  subCategory: "",
  subCategoryID:null,
  productName: "",
  productNameID:null,
};

const getVerticalName = (verticalID) => {
  if (verticalID === 1) {
    return "PARTS";
  } else if (verticalID === 2) {
    return "ACCESSORIES(A)";
  } else if (verticalID === 3) {
    return "ACCESSORIES(B)";
  } else {
    return "";
  }
};
const getVerticatID = (verticalID) => {
  if (verticalID >= 1 && verticalID <= 7) {
    return 1;
  } else if (verticalID >= 8 && verticalID <= 13) {
    return 2;
  } else if (verticalID >= 14 || verticalID <= 15) {
    return 3;
  } else {
    return null;
  }
};

const breadcrumbsSlice = createSlice({
  name: 'breadcrumbs',
  initialState,
  reducers: {
    toggleNavigation: (state) => {
      state.isNavOpen = !state.isNavOpen;
    },
    setBreadcrumb: (state, action) => {
      const {verticalID,verticalName,categoryID, categoryName,subCategoryID, subCategoryName, productID,productName } = action.payload;
      state.verticalID = verticalID && verticalID;
      state.vertical = verticalName ? verticalName : getVerticalName(verticalID);
      state.categoryID = categoryID && categoryID;
      state.category = categoryName || "";
      state.subCategoryID = subCategoryID ? subCategoryID: state.subCategoryID;
      state.subCategory = subCategoryName !== null ? subCategoryName : state.subCategory;
      state.productNameID = productID && productID;
      state.productName = productName || "";
    },
  },
});

export const { toggleNavigation, setBreadcrumb } = breadcrumbsSlice.actions;
export const selectIsNavOpen = (state) => state.breadcrumbs.isNavOpen;
export const selectBreadcrumbs = (state) => state.breadcrumbs;

export default breadcrumbsSlice.reducer;
